module.exports = __webpack_public_path__ + "static/media/Flipchart_aktiv.e8d48882.png";